export default {
    namespaced: true,
    state: () => ({
        search: '',
        status: 'All',
        extendedFilter: {
            Executers: {
                label: "Исполнитель",
                value: []
            },
            Authors: {
                label: "Автор",
                value: []
            },
            Controllers: {
                label: "Контроллер",
                value: []
            },
            Sphere: {
                label: "Сфера",
                value: null
            }
        },
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "controldate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_STATUS (state, payload){
            state.status = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
        },
        RESET_EXTENDED_FILTER(state) {
            Object.keys(state.extendedFilter).forEach(key => {
                state.extendedFilter[key].value = [];
            });
        },
        SET_EXTENDED_FILTER_EXECUTERS(state, payload) {
            state.extendedFilter.Executers.value = payload;
        },
        SET_EXTENDED_FILTER_CONTROLLERS(state, payload) {
            state.extendedFilter.Controllers.value = payload;
        },
        SET_EXTENDED_FILTER_SPHERE(state, payload) {
            state.extendedFilter.Sphere.value = payload;
        }   
    },
    getters: {
        getSearch: (state) => state.search,
        getStatus: (state) => state.status,
        getExtendedFilter: (state) => state.extendedFilter,
        getTableOptions: (state) => state.tableOptions,
    }
}